import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { popModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";

interface SaveChangesConfirmModalProps {
  onConfirm: () => void;
}

export const SaveChangesConfirmModal = ({
  onConfirm,
}: SaveChangesConfirmModalProps) => {
  const handleConfirm = () => {
    popModal();
    onConfirm();
  };

  return (
    <ModalWrapper className="flex w-[548px] flex-col gap-0 rounded-[10px] border border-line-normal bg-background-base p-0 shadow-2xl">
      <div className="flex flex-col gap-4 px-6 pb-5 pt-6">
        <h2 className="headline-1-semibold text-label-normal">
          수정 내용을 저장할까요?
        </h2>
        <p className="body-2-normal-regular text-label-alternative">
          저장 후에는 기존 데이터가 변경된 내용으로 대체됩니다.
        </p>
      </div>

      <div className="flex justify-end gap-2 px-6 pb-6">
        <Button
          variant="outlined"
          color="secondary"
          size={36}
          onClick={popModal}
          className="min-w-[90px]"
        >
          계속 편집
        </Button>
        <Button
          variant="solid"
          color="primary"
          size={36}
          onClick={handleConfirm}
          className="min-w-[82px]"
        >
          저장하기
        </Button>
      </div>
    </ModalWrapper>
  );
};
